import { useState } from "react";
import {
  Typography,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useApp } from "../../context/AppContext";
import { useLanguage } from "../../context/LanguageContext";

import "../../assets/style/SupportTickets.css";
import "../../assets/style/Styles.css";
import api from "../../api/api";

export default function CreateTicketForm({ onBack }) {
  const [subject, setSubject] = useState("");
  const [urgency, setUrgency] = useState("low");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { createTicket, user } = useApp();
  const { t } = useLanguage();

  const client_id = sessionStorage.getItem("client_id");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const ticketData = { subject, urgency, client_id };
      
      // Создаем тикет через контекст
      const newTicket = await createTicket(ticketData);

      // Добавляем сообщение к тикету
      const messageData = {
        ticket_id: newTicket.id,
        from: "client",
        content: message,
        author_name: user?.email || "client" // Добавляем email пользователя
      };

      await api.post("/messages", messageData, { 
        headers: { Authorization: `Bearer ${sessionStorage.getItem("accessToken")}` }
      });

      // Возвращаемся к списку тикетов
      onBack();
    } catch (err) {
      console.log(err.response?.data || err.message);
      alert("Error creating ticket. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-ticket-container">
      <div className="page-header">
        <Typography variant="h4" className="page-title">
          {t('createSupportTicket')}
        </Typography>
        <Button
          variant="outlined"
          className="go-back-button"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
        >
          {t('goBack')}
        </Button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          {/* Поле Subject */}
          <div className="form-field-wrapper">
            <TextField
              label={t('subject')}
              variant="outlined"
              fullWidth
              className="custom-textfield"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </div>

          {/* Поле Urgency */}
          <div className="form-field-wrapper create-ticket-container__select">
            <FormControl fullWidth variant="outlined" className="custom-select">
              <Select
                value={urgency}
                onChange={(e) => setUrgency(e.target.value)}>
                <MenuItem value="low">{t('low')}</MenuItem>
                <MenuItem value="medium">{t('medium')}</MenuItem>
                <MenuItem value="high">{t('high')}</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        {/* Поле Message */}
        <div className="form-field-wrapper">
          <TextField
            label={t('message')}
            variant="outlined"
            fullWidth
            multiline
            rows={6}
            className="custom-textfield"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
        </div>

        <div className="form-footer">
          <div className="footer-note">
            <InfoOutlinedIcon fontSize="small" />
            <Typography variant="caption">
              {t('supportTicketNote')}
            </Typography>
          </div>
          <Button
            type="submit"
            variant="contained"
            className="create-ticket-button"
            disabled={loading}
          >
            {loading ? t('creating') : t('createTicket')}
          </Button>
        </div>
      </form>
    </div>
  );
}
